module.exports = __webpack_public_path__ + "img/img_d.cc8f96f3.jpg";